import React from "react";
import "style.css";
import "tailwindcss/lib/css/preflight.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Hero from "components/Home";
import Features from "components/Features";
import About from "components/About";
import MatomeLife from "components/MatomeLife";
import FootballLife from "components/FootballLife";
import PublicNotice from "components/PublicNotice";
import Contact from "components/Contact";

function MainLandingPage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const anchor = location.hash.replace(/^#/, "");
      setTimeout(() => {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "center" });
        }
      }, 800); // AnimationRevealPageのアニメーション時間に合わせて調整
    }
  }, [location]);
  return (
    <AnimationRevealPage disabled={!!location.hash}>
      <Hero />
      <Features />
      <About />
      <MatomeLife />
      <FootballLife />
      <PublicNotice />
      <Contact />
    </AnimationRevealPage>
  );
}

export default MainLandingPage;